import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { AuthProvider } from "./contexts/AuthContext";
import { AuthGate } from "./app/AuthGate";

// In demo mode, swap AuthProvider for DemoAuthProvider so the user lands
// directly on the dashboard with synthesized session data (no login required).
// The `require` call is intentionally inside the condition so webpack can
// statically determine the branch is dead when the env var is absent and
// tree-shake the entire src/mocks/ subtree from the production bundle.
const Provider =
  process.env.REACT_APP_DEMO_MODE === "true"
    ? require("./mocks/DemoAuthProvider").DemoAuthProvider
    : AuthProvider;

export default function App() {
  return (
    <Provider>
      <BrowserRouter>
        <AuthGate />
      </BrowserRouter>
      <Analytics />
      <SpeedInsights />
    </Provider>
  );
}
